import { Modal, Button, Block } from '@carta/ink';
import ModalIllustration from "../../../../src/content/deprecation/migration-guides/images/ModalIllustration";
import * as React from 'react';
export default {
  Modal,
  Button,
  Block,
  ModalIllustration,
  React
};